// @ts-nocheck
import { useAIGenerator } from './hooks/useAIGenerator';
import { AIGeneratorForm } from './AIGeneratorForm';
import { t } from 'i18next';
import * as Sentry from '@sentry/react';
import { toast } from 'react-toastify';

const AIContentGenerator = ({ disabled, text, setTextGenerated, className, onStartGeneration }) => {
    const toneOptions = [
        { label: t("AI.Tone1"), value: "Résume ce contenu de manière concise et professionnelle pour un public corporate." },
        { label: t("AI.Tone2"), value: "Résume ce contenu avec énergie et enthousiasme! Utilise des points d'exclamation et un ton positif." },
        { label: t("AI.Tone3"), value: "Résume ce contenu comme si tu parlais à un ami, avec un ton chaleureux et naturel." },
        // { label: "Fun", value: "Résume ce contenu de manière drôle et décontractée. N'hésite pas à être créatif!" }
    ];

    const sizeOptions = [
        { label: "S", value: "Résume ce contenu en quelques paragraphes, max 3" },
        { label: "M", value: "Résume ce contenu en plusieurs paragraphes, max 10" },
        { label: "XL", value: "Développe ce contenu pour dépasser le contenu d'au moins 3 paragraphes" }
    ];

    const langOptions = [
        { label: "Fr", value: "en français" },
        { label: "En", value: "en anglais" }
    ];
    const { options, updateOption, generateContent } = useAIGenerator();

    const handleOptionChange = (key, value) => {
        updateOption(key, value);
    };

    const handleGenerate = async () => {
        onStartGeneration();

        // Always hand a text back: the caller keeps the editor disabled
        // until setTextGenerated runs.
        try {
            const generatedText = await generateContent(
                'Contenu',
                text,
                "Tu es un expert en résumé de contenu qui adapte ton style et la longueur du texte selon les demandes.",
                400
            );
            setTextGenerated(generatedText);
        } catch (error) {
            Sentry.captureException(error);
            toast.error(t("AI.Error"));
            setTextGenerated(text);
        }
    };

    return (
        <AIGeneratorForm
            className={className}
            title={t("AI.TitleContent")}
            onOptionChange={handleOptionChange}
            options={options}
            onGenerate={handleGenerate}
            toneOptions={toneOptions}
            sizeOptions={sizeOptions}
            langOptions={langOptions}
            disabled={disabled}
            warningMessage={t("AI.Warning")}
        />
    );
};

export default AIContentGenerator;